import React from "react";
import { connect } from "react-redux";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import {
  Drawer,
  AppBar,
  Toolbar,
  List,
  CssBaseline,
  Typography,
  Divider,
  IconButton,
  ListItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@material-ui/core";
import { Menu, PowerSettingsNewOutlined } from "@material-ui/icons";
import logo from "../../config/img/logo.png";
import { firebaseLogout } from "../../store/actions/firebase.action";
import { URL, SANDBOX } from "../../config/config";
import laundrySVG from "../../asset/svg/laundry.svg";
import contactSVG from "../../asset/svg/contacts-book.svg";
import reportSVG from "../../asset/svg/report.svg";
import userSVG from "../../asset/svg/user.svg";
import buildingSVG from "../../asset/svg/building.svg";
import templateSVG from "../../asset/svg/template.svg";
import formulaSVG from "../../asset/svg/formula.svg";
import rosterSVG from "../../asset/svg/roster.svg";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(8) + 1,
    },
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
}));

const SignInLink = (props) => {
  const classes = useStyles();
  // const theme = useTheme();
  const [open, setOpen] = React.useState(false);

  const handleDrawerOpen = () => {
    setOpen(!open);
  };
  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open,
        })}
      >
        <Toolbar>
          <IconButton color="inherit" aria-label="open drawer" onClick={handleDrawerOpen} edge="start">
            <Menu />
          </IconButton>
          <Typography variant="h6" noWrap>
            {props.title ? props.title : ""}
            {SANDBOX ? " - SandBox" : ""}
          </Typography>
          <div className="appbar-right">{props.right ? props.right : null}</div>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
      >
        <div className={classes.toolbar}>
          <img src={logo} alt="logo" className="nav-logo" />
        </div>
        <Divider />
        <List>
          <ListItem button component="a" href={URL.home}>
            <Tooltip title="User Management" aria-label="User Management" placement="top">
              <ListItemIcon>
                <img className="side-menu-icon" alt="User Management" src={userSVG} />
              </ListItemIcon>
            </Tooltip>
            <ListItemText>User Management</ListItemText>
          </ListItem>

          <ListItem button component="a" href={URL.branch}>
            <Tooltip title="Branch Management" aria-label="Branch Management" placement="top">
              <ListItemIcon>
                <img className="side-menu-icon" alt="Branch Management" src={buildingSVG} />
              </ListItemIcon>
            </Tooltip>
            <ListItemText>Branch Management</ListItemText>
          </ListItem>

          <ListItem button component="a" href={URL.reportManagement}>
            <Tooltip title="Reports" aria-label="Reports" placement="top">
              <ListItemIcon>
                <img className="side-menu-icon" alt="Reports" src={reportSVG} />
              </ListItemIcon>
            </Tooltip>
            <ListItemText>Reports</ListItemText>
          </ListItem>

          <ListItem button component="a" href={URL.productManagement}>
            <Tooltip title="Products & Services" aria-label="Products & Services" placement="top">
              <ListItemIcon>
                <img className="side-menu-icon" alt="Product & Service" src={laundrySVG} />
              </ListItemIcon>
            </Tooltip>
            <ListItemText>Products & Services</ListItemText>
          </ListItem>

          <ListItem button component="a" href={URL.contactsManagement}>
            <Tooltip title="Contacts" aria-label="Contacts" placement="top">
              <ListItemIcon>
                <img className="side-menu-icon" alt="Contacts" src={contactSVG} />
              </ListItemIcon>
            </Tooltip>
            <ListItemText>Contacts</ListItemText>
          </ListItem>

          <ListItem button component="a" href={URL.templateManagement}>
            <Tooltip title="Order Templates" aria-label="Order Templates" placement="top">
              <ListItemIcon>
                <img className="side-menu-icon" alt="Order Templates" src={templateSVG} />
              </ListItemIcon>
            </Tooltip>
            <ListItemText>Order Templates</ListItemText>
          </ListItem>

          <ListItem button component="a" href={URL.formulaManagement}>
            <Tooltip title="Formula Management" aria-label="Formula Management" placement="top">
              <ListItemIcon>
                <img className="side-menu-icon" alt="Formula Management" src={formulaSVG} />
              </ListItemIcon>
            </Tooltip>
            <ListItemText>Formula Management</ListItemText>
          </ListItem>

          <ListItem button component="a" href={URL.roster}>
            <Tooltip title="Roster Management" aria-label="Roster Management" placement="top">
              <ListItemIcon>
                <img className="side-menu-icon" alt="Roster Management" src={rosterSVG} />
              </ListItemIcon>
            </Tooltip>
            <ListItemText>Roster Management</ListItemText>
          </ListItem>
        </List>
        <Divider />
        <List>
          <ListItem button onClick={props.firebaseLogout}>
            <ListItemIcon>
              <PowerSettingsNewOutlined />
            </ListItemIcon>
            <ListItemText>Logout</ListItemText>
          </ListItem>
        </List>
      </Drawer>
    </div>
  );
};
const mapStateToProps = (state) => ({
  setting: state.firebaseWeb.setting,
});

export default connect(mapStateToProps, {
  firebaseLogout,
})(SignInLink);
